/* Progressive enhancement: both panels are server-rendered and readable without JS. */
(() => {
  if (customElements.get('andcharlie-product-tabs')) return;
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.ready ||= () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, { once: true });
      else this.initialize();
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.ready);
      window.removeEventListener('hashchange', this.onHash);
    }

    initialize() {
      if (this.hasAttribute('data-disabled')) return;
      if (!this.initialized) {
        const list = this.querySelector('[data-ac-tab-list]');
        this.panels = [...this.querySelectorAll('[data-ac-tab-panel]')].filter(panel => !panel.hidden);
        this.tabs = [...list.querySelectorAll('[data-ac-tab]')].filter(tab => {
          const present = this.panels.some(panel => panel.dataset.acTabPanel === tab.dataset.acTab);
          tab.hidden = !present;
          return present;
        });
        if (this.tabs.length < 2) return;
        this.initialized = true;
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          this.panels[index].querySelector(':scope > .ac-product-details__heading')?.classList.add('visually-hidden');
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', event => {
            const next = { ArrowRight: (index + 1) % this.tabs.length, ArrowLeft: (index + this.tabs.length - 1) % this.tabs.length, Home: 0, End: this.tabs.length - 1 }[event.key];
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          });
        });
        this.onHash = () => {
          let id;
          try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
          const target = document.getElementById(id);
          const index = this.panels.findIndex(panel => target && panel.contains(target));
          if (index < 0) return;
          this.select(index);
          target.scrollIntoView({ block: 'start' });
        };
        this.select(0);
        list.hidden = false;
        this.classList.add('ac-product-tabs--ready');
      }
      window.addEventListener('hashchange', this.onHash);
      this.onHash();
    }

    select(index) {
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[current].hidden = !selected;
      });
    }
  }
  customElements.define('andcharlie-product-tabs', ProductTabs);
})();
